import Api from '../../api'
import axios from '@/js/api'
// import Vue from 'vue'
// import { Message } from 'element-ui'
import router from '../../router'
import date from '../../js/date.js'
import _ from 'lodash';
// 通用的处理函数，将 OptionGuid 从数组转换为字符串
function convertOptionGuid(list) {
	return _.cloneDeep(list).map(item => {
		if (Array.isArray(item.OptionGuid)) {
			item.OptionGuid = item.OptionGuid.join(','); // 使用逗号连接数组元素
		}
		return item;
	});
}
// 通用的处理函数，将 URL 截取到最后一个斜杠之前
function truncateUrlBeforeLastSlash(url) {
    const lastSlashIndex = url.lastIndexOf('/');
    if (lastSlashIndex > 0 && lastSlashIndex > url.indexOf('://') + 2) {
        return url.substring(0, lastSlashIndex);
    }
    
    return url; // 如果没有找到合适的斜杠，返回原URL
}
const state = {
	totalsecond: 0,
	listParameter: {
		PageIndex: 1, //分页
		PageCount: 10, //分页
		keyName: '', //关键词
		startDate: '', //开始时间
		endDate: '', //结束时间
		type: 1, //审核医生传1，技师传2
		status: 130, //120抽样中     125进行中   130质控完成
		isRead: 2, //1已读0未读2全部
	},
	// 申诉列表
	appealParameter: {
		PageIndex: 1, //分页
		PageCount: 10, //分页
		appealStatus: '0',
		accNo: '',
		startDt: '',
		endDt: '',
		modalityType: ''
	},
	pageIndex: {
		page: 1,
		pageIndex: 1
	},
	lists: {
		status: 0, //10待质控 20进行中 50已完成
		keyword: '', //关键词搜索
		startDate: '', //开始时间
		endDate: '', //结束时间
		PageIndex: 1, //分页
		PageCount: 10, //分页
	},
	detaisParameter: {
		reportGuid: '',
		samplingTaskGuid: '',
		ExpertUserGuid: 'e09a3f81-d3e0-4dca-8750-1e62a6afec2e'
	},
	pickerDate: {
		date: []
	},
	list: [],
	total: 0,
	ReportIds: [],
	doctor: {
		complete: 0,
		sampling: 0,
		pending: 0,
	},
	experts: {
		complete: 0,
		sampling: 0,
		pending: 0,
	},
	//详情
	splitScreen: false,
	isSubmint: false,
	isSubmintflag: false,
	isSeriousSubmint: {
		flag: false
	},
	//报告详情
	reportDetails: {},
	doctorQCImg: null,
	doctorQCReport: null,
	doctorQCHistory: null,
	grade: [{
		name: '报告评分',
		type: 'report'
	}, {
		name: '影像评分',
		type: 'img',
	}],
	gradeIndex: 0,
	gradeType: 'report',
	remark: {
		img: '',
		imgNum: 0,
		report: '',
		reportNum: 0,
		history: '',
		historyNum: 0
	},
	anyNoScoreImg: false, //影像存在没有评分选项
	anyNoScoreReport: false, //报告存在没有评分选项
	anyNoScoreHistory: false, //病史存在没有评分选项

	needNoteImg: false, //影像存在扣分切没填备注选项
	needNoteReport: false, //报告存在扣分切没填备注选项
	needNoteHistory: false, //病史存在扣分切没填备注选项

	anyNoScoreImgserious: false, //影像存在没有评分选项
	anyNoScoreReportserious: false, //报告存在没有评分选项
	anyNoScoreHistoryserious: false, //病史存在没有评分选项

	needNoteImgserious: false, //影像存在扣分切没填备注选项
	needNoteReportserious: false, //报告存在扣分切没填备注选项
	needNoteHistoryserious: false, //病史存在扣分切没填备注选项
	//审核医生入参
	reportDoctorPar: {
		data: [date.start, date.end],
		enddt: new Date(date.end).toLocaleDateString().replace(/\//g, '-'),
		startdt: new Date(date.start).toLocaleDateString().replace(/\//g, '-')
	},
	Summary: [],
	SummaryTotalReportCount: 0,
	DashboradArr: {
		enddt: new Date(date.end).toLocaleDateString().replace(/\//g, '-'),
		startdt: new Date(date.start).toLocaleDateString().replace(/\//g, '-'),
		type: 1,
		data: [date.start, date.end]
	},
	TaskListArr: {
		statusList: '',
		keyword: '',
		startDate: '',
		endDate: '',
		pageIndex: 1,
		pageCount: 10
	},
	expertinfoTaskListArr: {
		statusList: '',
		keyword: '',
		startDate: '',
		endDate: '',
		pageIndex: 1,
		pageCount: 10
	},
	DashboradList: {},
	experListShow: false,
	//审核医生任务列表
	TaskListArrData: {},
	taskListShow: false,
	taskListTitle: {},
	statusList: 0,
	statusTab: true,
	exportsListArrData: {},
	exportsListTitle: {},
	samplingTaskGuid: {
		id: 1234,
		ExpertUserId: 123
	},
	doctorTaskStatus: '',
	doctorTaskType: {
		type: ''
	},
	exportTackStatus: '',
	role: 'doctor',
	getReporterReportListArr: {
		PageIndex: 1, //分页
		PageCount: 10, //分页
		keyName: '', //关键词
		startDate: '', //开始时间
		endDate: '', //结束时间
		type: 1, //审核医生传1，技师传2
		status: 120, //120抽样中 125进行中 130质控完成
		isRead: 2, //1已读0未读2全部
		isUnqualified: false,
		scoreItem: ''
	},
	getDashboradData: {},
	chartsLoading: false,
	detalloading: false,
	qcresultsByTaskList: [],
	qcresultsList: {
		Name: '',
		expertUserId: '',
		ReportGuid: '',
		SamplingTaskGuid: ''
	},
	totalScore: {
		ImageScore: '',
		ReportScore: '',
		HistoryScore: ''
	},
	doctorQCReportIndex: 0,
	doctorQCReportIndexserious: 0,
	appealInfo: {
		info: []
	},
	drawer: false,
	appealList: {

	},
	appealListIndex: 0,
	appealInfoList: {},
	appealDetail: [],
	// 仲裁管理员申诉列表
	adminappealParameter: {
		type: 2,
		PageIndex: 1, //分页
		pageCount: 10, //分页
		appealStatus: 0,
		accNo: '',
		startDt: '',
		endDt: '',
		modalityType: '',
		taskId: ''
	},
	// 仲裁专家申诉列表
	expertParameter: {
		type: 2,
		pageIndex: 1, //分页
		pageCount: 10, //分页
		appealStatus: 0,
		accNo: '',
		startDt: '',
		endDt: '',
		modalityType: '',
		taskId: ''
	},
	expertList: [],
	adminappealInfoList: [],
	appealExpertList: [],
	appealExpertListParameter: {
		"Keyword": "",
		"ExpertFromType": 0,
		"ExpertMajor": 0,
		"SrcHospitalGuid": "",
		"ExpertLevelType": "",
		"StartDate": "",
		"EndDate": "",
		"ModalityTypes": "",
		"Bodyparts": "",
		"PageIndex": 1,
		"PageCount": 10,
		"Enable": -1
	},
	modifyShow: false,
	respondShow: false,
	reviewName: {
		SubjectType: 0
	},
	reportSpecialSIList: [],
	imageSpecialSIList: [],
	historySpecialSIList: [],//病史评分
	//申诉严重扣分项
	reportSpecialSIListserious: [],
	imageSpecialSIListserious: [],
	totalScoreserious: {
		ImageScore: 100,
		ReportScore: 100
	},
	doctorQCImgserious: null,
	doctorQCReportserious: null,
	gradeIndexserious: 0,
	remarkserious: {
		img: '',
		imgNum: 0,
		report: '',
		reportNum: 0
	},
	isSubmintserious: false,
	isSubmintflagserious: false,
	isSeriousSubmintserious: {
		flag: false
	},
	appealLoading: false,
};
const getters = {

};
const mutations = {
	setSpecialList(state, item) {
		if (state.gradeType == 'report') {
			state.totalScore.ReportScore = 0;
			state.reportSpecialSIList[item.index].Score = item.checked ? 100 : 0;
		} else if (state.gradeType == 'img') {
			state.totalScore.ImageScore = 0;
			state.imageSpecialSIList[item.index].Score = item.checked ? 100 : 0;
		} else if (state.gradeType == 'history') {
			state.totalScore.HistoryScore = 0;
			state.historySpecialSIList[item.index].Score = item.checked ? 100 : 0;
		}
	},
	changerespondShow(state, val) {
		state.respondShow = val;
	},
	resetappealDetail(state, arr) {
		state.appealDetail = [];
	},
	drawerShow(state, arr) {
		state.drawer = arr;
	},
	setTabShow(state, arr) {
		state.statusTab = arr;
	},
	setDetalLoading(state, arr) {
		state.detalloading = arr;
	},
	setChartsLoading(state, arr) {
		state.chartsLoading = arr;
	},
	setAppealLoading(state, arr) {
		state.appealLoading = arr;
	},
	//当前角色
	isRole(state, arr) {
		state.role = arr;
	},
	setAppealDetail(state, arr) {
		state.appealDetail = [];
		let role = JSON.parse(localStorage.getItem('user')).roleName;
		let appealDetail = arr.data.StatusList;
		for (let i = 0; i < appealDetail.length; i++) {
			if (appealDetail[i].DateTime != '') {
				appealDetail[i].icon = "el-icon-check";
			} else if (appealDetail[i].DateTime == '') {
				appealDetail[i - 1].icon = "el-icon-location";
				appealDetail[i].icon = "";
				break;
			}
		}
		let detail = arr.data.Details;
		for (let i = 0; i < detail.length; i++) {
			detail[i].notFilledIn = false;
			detail[i].imageList = [];
			if (role.contain('仲裁专家') && arr.data.AppealStatus == 144) {
				detail[i].ManagerScore = detail[i].RawScore;
			}
			if (role.contain('仲裁管理') || role.contain('仲裁专家')) {
				if (arr.data.AppealStatus == 146) {
					detail[i].ManagerOptionGuid = detail[i].ExpertOptionGuid;
					detail[i].ManagerScore = detail[i].ExpertScore;
					detail[i].ManagerResponse = detail[i].ExpertResponse;
					detail[i].ManagerResponsePicUrls = detail[i].ExpertResponsePicUrls;
					detail[i].imageList = detail[i].ExpertResponsePicUrls;
				}
				if (arr.data.AppealStatus == 142 || arr.data.AppealStatus == 144) {
					detail[i].ManagerScore = detail[i].RawScore;
				}
			}

			if (arr.data.AppealStatus >= 142 && arr.data.AppealStatus <= 148) {
				detail[i].IsBtnShow = true;
				if (detail[i].RawScore == detail[i].ManagerScore) {
					detail[i].Ismodify = false;
				} else {
					detail[i].Ismodify = role.contain('仲裁专家') && arr.data.AppealStatus == 144 ? false : true;
				}
			} else {
				detail[i].IsBtnShow = false;
			}

		}
		if (role.contain('仲裁专家')) {
			state.modifyShow = arr.data.AppealStatus == 144 ? true : false;
		} else if (role.contain('仲裁管理')) {
			state.modifyShow = arr.data.AppealStatus == 142 || arr.data.AppealStatus == 146 ? true : false;
		} else if (role.contain('医生') || role.contain('技师')) {
			state.respondShow = arr.data.AppealStatus == 146 ? false : true;
		}
		state.appealDetail = JSON.parse(JSON.stringify(arr.data));
	},
	//审核医生任务列表
	GetTaskListMu(state, arr) {
		state.TaskListArrData = arr.data;
		state.total = arr.data.TotalCount;
		state.doctor.complete = arr.data.QCedCount;
		state.doctor.sampling = arr.data.QCingCount;
		state.doctor.pending = arr.data.ToQCCount;
	},
	// toop专家列表赋值
	GetQCResultsByTaskMu(state, arr) {
		state.qcresultsByTaskList = arr.data.Experts;
	},
	//专家任务列表
	expertinfoGetTaskListMu(state, arr) {
		state.exportsListArrData = arr.data;
		state.total = arr.data.TotalCount;
		state.experts.complete = arr.data.QCedCount;
		state.experts.sampling = arr.data.QCingCount;
		state.experts.pending = arr.data.ToQCCount;
		//      if(arr.data.SamplingTasks.length>0){
		//      	state.statusList = arr.data.SamplingTasks[0].Status;
		//      }

	},
	taskListShowMu(state, arr) {
		state.taskListShow = arr;
	},
	experListShowMu(state, arr) {
		state.experListShow = arr;
	},
	//审核医生首页数据
	getDashboradMu(state, arr) {
		state.getDashboradData = arr.data.Response;
	},
	//情况备注与印象分
	setremark(state) {
		state.remark.img = '';
		state.remark.imgNum = 0;
		state.remark.report = '';
		state.remark.reportNum = 0;
		state.remark.history = '';
		state.remark.historyNum = 0;
	},
	//初始化参数
	clearInit(state) {
		state.listParameter.PageIndex = 1;
		state.listParameter.keyName = ''
		state.listParameter.startDate = '';
		state.listParameter.endDate = '';
		state.pickerDate.date = [];
		state.splitScreen = false;
	},
	//是否可以编辑
	setIsSubmint(state, arr) {
		console.log(arr)
		state.isSubmint = arr;
		state.isSeriousSubmint.flag = arr;
	},
	//是否可以编辑
	setIsSubmintserious(state, arr) {
		state.isSubmintserious = arr;
		state.isSeriousSubmintserious.flag = arr;
	},
	setisSubmintflag(state, arr) {
		state.isSubmintflag = arr;
	},
	//审核医生
	SetReporterReportList(state, arr) {
		state.list = arr.data.Reports;
		state.totalsecond = arr.data.TotalCount;
		state.doctor.sampling = arr.data.ToQCCount;
		state.doctor.pending = arr.data.QCedCount;
	},
	currentChanges(state, val) {
		state.listParameter.PageIndex = val;
	},
	currentChangesSecond(state, val) {
		state.pageIndex.page = val;
	},
	setDatePicker(state, val) {
		if (val) {
			state.listParameter.startDate = date.dataNumber(val[0]);
			state.listParameter.endDate = date.dataNumber(val[1]);
		} else {
			state.listParameter.startDate = '';
			state.listParameter.endDate = '';
		}
	},
	setReportGuid(state, val) {
		state.ReportIds = val
	},
	setsamplingTaskGuid(state, val) {
		state.samplingTaskGuid.id = val;
	},
	setDoctorType(state, val) {
		state.listParameter.type = val
	},
	doctorDoctorStatus(state, val) {
		state.listParameter.status = val
		state.TaskListArr.statusList = val
		state.expertinfoTaskListArr.statusList = val
		state.statusList = val;
	},
	exportDoctorStatus(state, val) {
		state.doctorTaskStatus = val
		state.doctorTaskType.type = val
	},
	exportDoctorStatusMu(state, val) {
		state.exportTackStatus = val;
	},
	//报告专家
	setExpertTaskList(state, arr) {
		state.list = arr.data.Reports;
		state.totalsecond = arr.data.TotalCount;
		state.experts.complete = arr.data.QCingCount;
		state.experts.sampling = arr.data.ToQCCount;
		state.experts.pending = arr.data.QCedCount;
	},
	//分屏
	setSplitScreen(state, arr) {
		state.splitScreen = arr;
	},
	//获取详情
	setDetailsParameter(state, arr) {
		state.detaisParameter.reportGuid = arr.reportGuid;
		state.detaisParameter.samplingTaskGuid = arr.samplingTaskGuid;
		state.detaisParameter.ExpertUserGuid = arr.ExpertUserGuid;
	},
	SetReportinfo(state, arr) {
		state.reportDetails = arr.data.Report;
		state.totalScore = arr.data.Report;
		state.reviewName.SubjectType = arr.data.SubjectType;
		if (state.reportDetails.AllImage && state.reportDetails.AllImage != '') {
			state.reportDetails.AllImage = state.reportDetails.AllImage.split(',');
		}

		if (state.reportDetails.KeyImage && state.reportDetails.KeyImage != '') {
			state.reportDetails.KeyImage = state.reportDetails.KeyImage.split(',');
		}
		if (state.reportDetails.PacsUrl && state.reportDetails.PacsUrl != '') {
			state.reportDetails.PacsUrl = state.reportDetails.PacsUrl.split('|');
		}
		if (arr.data.Report.ImageQCList) {
			state.doctorQCImg = arr.data.Report.ImageQCList;
			state.doctorQCImg.forEach(item => {
				item.notSelected = false;
				item.notFilledIn = false;
			})
		}
		let doctorQCImg = arr.data.Report.ReportQCList;
		if (state.doctorTaskStatus == '125') {
			for (let i = 0; i < doctorQCImg.length; i++) {
				doctorQCImg[i].IsNoteShow = true;
			}
			state.doctorQCReport = doctorQCImg;
		} else {
			state.doctorQCReport = arr.data.Report.ReportQCList;
		}
		state.doctorQCReport.forEach(item => {
			item.notSelected = false;
			item.notFilledIn = false;
		})
		// state.doctorQCHistory.forEach(item => {
		// 	item.notSelected = false;
		// 	item.notFilledIn = false;
		// })
		console.log(state.doctorQCReport);
		state.gradeIndex = 0;
		state.remark.img = arr.data.Report.ImageNote;
		state.remark.imgNum = arr.data.Report.ImageImpressionScore;
		state.remark.report = arr.data.Report.ReportNote;
		state.remark.reportNum = arr.data.Report.ReportImpressionScore;
	},
	SetReportDetail(state, arr) {
		console.log(arr.data ,'--------------')
		if(arr.data.Kind== 2){
			let urlArray =  arr.data.Report.ExaminationInformation.PacsUrl ? arr.data.Report.ExaminationInformation.PacsUrl.split('|') : []//pacs地址
			const baseUrl = truncateUrlBeforeLastSlash(urlArray[0])
			const newUrl = baseUrl + "/"+ urlArray.map(url => url.split("/").pop())
			.join("--");
			console.log(newUrl,'newUrl');
			state.reportDetails = {
				...arr.data.Report,
				kind:2,//2 核医学相关信息
				Kind:2,//2 核医学相关信息
				AccNo:arr.data.Report.ExaminationInformation.AccNo,// 编号
				// AllImage: [],//超声影像 所有图片
				// KeyImage: [],//关键图
				PacsUrl:[newUrl],
				// PatientNo: '',//就诊人编号
				// ExaminDate: '',//检查日期
				// InhospitalNo: '',//住院号
				// BedNo: '',//床号
				// HealthHistory: '',//病史
				// IsPositive:'',//阴阳性
				PatientName: arr.data.Report.Patient.Name,//姓名
				Gender: arr.data.Report.Patient.Gender,//性别
				CurrentAge: arr.data.Report.Patient.Age,//年龄
				ApplyAdpt: arr.data.Report.Patient.Department,//科室
				BodyParts: arr.data.Report.Patient.ModalityType,//检查部位
				CheckingItems: arr.data.Report.Patient.ExaminationItems,//检查项目
				WysText: arr.data.Report.ImagingFindings,//影像学表现
				DiagnoseWys:arr.data.Report.ImagingDiagnosis,//影像学诊断
				WygText: arr.data.Report.ImagingDiagnosis,//影像学诊断
				DiagnoseWyg:arr.data.Report.ImagingDiagnosis,//影像学诊断
				ReportSubmitterName:arr.data.Report.ReportSubmitterName,//报告医师
				FirstApproverName:arr.data.Report.FirstApproverName,//审核医师
				FirstApproveDt:arr.data.Report.ReportSubmitDt,//报告时间
				ReportQCList:arr.data.Report.ReportReview.BasicReductionItems,//报告评分
				reportSpecialSIList:arr.data.Report.ReportReview.SeriousReductionItems,//报告评分
				ImageQCList:arr.data.Report.ImagingReview.CommonItems,//影像评分
				imageSpecialSIList:arr.data.Report.ImagingReview.SpecialItems,//影像评分
				doctorQCHistory:arr.data.Report.DiseaseHistoryReview.CommonItems,//病史评分
				historySpecialSIList:arr.data.Report.DiseaseHistoryReview.SpecialItems,//病史评分

			}
			// 评分模块
			state.ReportQCList = arr.data.Report.ReportReview.BasicReductionItems//报告评分
			state.reportSpecialSIList = arr.data.Report.ReportReview.SeriousReductionItems//报告评分
			state.ImageQCList = arr.data.Report.ImagingReview.CommonItems//影像评分
			state.imageSpecialSIList = arr.data.Report.ImagingReview.SpecialItems//影像评分
			state.doctorQCHistory = arr.data.Report.DiseaseHistoryReview.CommonItems//病史评分
			state.historySpecialSIList = arr.data.Report.DiseaseHistoryReview.SpecialItems//病史评分
			state.totalScore.HistoryScore = arr.data.Report.SampTaskScoreDetail.DiseaseHistoryScore;//病史评分
			state.totalScore.ImageScore = arr.data.Report.SampTaskScoreDetail.ImageScore;//影像评分
			state.totalScore.ReportScore = arr.data.Report.SampTaskScoreDetail.ReportScore;//报告评分
			// 影像评分
			if (arr.data.Report.ImagingReview.CommonItems) {
				state.doctorQCImg = arr.data.Report.ImagingReview.CommonItems;
				state.doctorQCImg.forEach(item => {
					item.notSelected = false;
				})
			}
			// 报告评分
			let doctorQCImg = arr.data.Report.ReportReview.BasicReductionItems;
			if (state.doctorTaskStatus == '125') {
				if (doctorQCImg) {
					for (let i = 0; i < doctorQCImg.length; i++) {
						doctorQCImg[i].IsNoteShow = true;
					}
					state.doctorQCReport = doctorQCImg;
				}
			} else {
				state.doctorQCReport = arr.data.Report.ReportReview.BasicReductionItems;
			}
			if (state.doctorQCReport != null) {
				state.doctorQCReport.forEach(item => {
					item.notSelected = false;
					item.notFilledIn = false;
				})
			}
			// 病史评分
			state.doctorQCHistory = arr.data.Report.DiseaseHistoryReview.CommonItems//病史评分
			// 权限管理？
			let role = JSON.parse(localStorage.getItem('user')).roleName;
	
			if (role.contain('仲裁管理') || role.contain('仲裁专家')) {
				if (state.adminappealParameter.type == 3) {
					state.gradeIndex = 1;
					state.gradeType = 'img';
				} else {
					state.gradeIndex = 0;
					state.gradeType = 'report';
				}
			}
			//tab切换
			state.grade = [];
			// let imgs = state.doctorQCImg != null ? true : false,
			// 	reports = state.doctorQCReport != null ? true : false;
			if (arr.data.Report.Category == 2) {
				state.gradeType = 'report'
			} else if (arr.data.Report.Category == 1) {
				state.gradeType = 'img'
			} else {
				state.gradeType = 'report'
			}
			// 评分模块
			state.grade=[
				{ name: '报告评分', type: 'report' },
				{ name: '影像评分', type: 'img' },
				{ name: '病史评分', type: 'history' }
			]
			state.gradeIndex = 0;
			if (role.contain('技师')) {
				state.grade = [{ name: '影像评分', type: 'img' }]
				state.gradeIndex = state.grade.length > 1 ? 1 : 0;
				state.gradeType = 'img';
			} else if (role.contain('医生')) {
				state.grade = [{ name: '报告评分', type: 'report' }]
				state.gradeIndex = 0;
				state.gradeType = 'report';
			}
			state.remark.img = arr.data.Report.SampTaskScoreDetail.ImageNote || '';
			state.remark.imgNum = arr.data.Report.SampTaskScoreDetail.ImageImpressionScore || 0;
			state.remark.report = arr.data.Report.SampTaskScoreDetail.ReportNote || '';
			state.remark.reportNum = arr.data.Report.SampTaskScoreDetail.ReportImpressionScore || 0;
			state.remark.history = arr.data.Report.SampTaskScoreDetail.DiseaseHistoryNote || '';
			state.remark.historyNum = arr.data.Report.SampTaskScoreDetail.DiseaseHistoryImpressionScore || 0;
		}else{
			state.reportDetails = arr.data.Report.Report
			state.reportSpecialSIList = arr.data.Report.ReportSpecialSIList === null ? [] : arr.data.Report.ReportSpecialSIList;
			state.imageSpecialSIList = arr.data.Report.ImageSpecialSIList === null ? [] : arr.data.Report.ImageSpecialSIList;
			state.totalScore = arr.data.Report;
			state.reviewName.SubjectType = arr.data.Report.SubjectType;
			if (state.reportDetails.AllImage && state.reportDetails.AllImage != '') {
				state.reportDetails.AllImage = state.reportDetails.AllImage.split(',');
			}
	
			if (state.reportDetails.KeyImage && state.reportDetails.KeyImage != '') {
				state.reportDetails.KeyImage = state.reportDetails.KeyImage.split(',');
			}
			if (state.reportDetails.PacsUrl && state.reportDetails.PacsUrl != '') {
				state.reportDetails.PacsUrl = state.reportDetails.PacsUrl.split('|');
			}
			if (arr.data.Report.ImageQCList) {
				state.doctorQCImg = arr.data.Report.ImageQCList;
				state.doctorQCImg.forEach(item => {
					item.notSelected = false;
					item.notFilledIn = false;
				})
			}
			let doctorQCImg = arr.data.Report.ReportQCList;
			if (state.doctorTaskStatus == '125') {
				if (doctorQCImg) {
					for (let i = 0; i < doctorQCImg.length; i++) {
						doctorQCImg[i].IsNoteShow = true;
					}
					state.doctorQCReport = doctorQCImg;
				}
			} else {
				state.doctorQCReport = arr.data.Report.ReportQCList;
			}
			if (state.doctorQCReport != null) {
				state.doctorQCReport.forEach(item => {
					item.notSelected = false;
					item.notFilledIn = false;
				})
			}
	
			let role = JSON.parse(localStorage.getItem('user')).roleName;
	
			if (role.contain('仲裁管理') || role.contain('仲裁专家')) {
				if (state.adminappealParameter.type == 3) {
					state.gradeIndex = 1;
					state.gradeType = 'img';
				} else {
					state.gradeIndex = 0;
					state.gradeType = 'report';
				}
			}
			//tab切换
			state.grade = [];
			// let imgs = state.doctorQCImg != null ? true : false,
			// 	reports = state.doctorQCReport != null ? true : false;
			if (arr.data.Report.Category == 2) {
				state.gradeType = 'report'
			} else if (arr.data.Report.Category == 1) {
				state.gradeType = 'img'
			} else {
				state.gradeType = 'report'
			}
			const category = arr.data.Report.Category;
			const gradeMapping = {
				1: [{ name: '影像评分', type: 'img' }],
				2: [{ name: '报告评分', type: 'report' }],
				3: [
					{ name: '报告评分', type: 'report' },
					{ name: '影像评分', type: 'img' }
				],
				4: [
					{ name: '报告评分', type: 'report' },
					{ name: '影像评分', type: 'img' },
					{ name: '病史评分', type: 'history' }
				]
			};
	
			if (gradeMapping[category]) {
				state.grade.push(...gradeMapping[category]);
			}
	
			state.gradeIndex = 0;
			console.log(state.grade,'state.grade');
			if (role.contain('技师')) {
				state.grade = [{ name: '影像评分', type: 'img' }]
				state.gradeIndex = state.grade.length > 1 ? 1 : 0;
				state.gradeType = 'img';
			} else if (role.contain('医生')) {
				state.grade = [{ name: '报告评分', type: 'report' }]
				state.gradeIndex = 0;
				state.gradeType = 'report';
			}
			state.remark.img = arr.data.Report.ImageNote;
			state.remark.imgNum = arr.data.Report.ImageImpressionScore;
			state.remark.report = arr.data.Report.ReportNote;
			state.remark.reportNum = arr.data.Report.ReportImpressionScore;
			
		}
	},
	// SetReportDetail(state, arr) {
	// 	state.reportDetails = arr.data.Report.Report
	// 	state.reportSpecialSIList = arr.data.Report.ReportSpecialSIList === null ? [] : arr.data.Report.ReportSpecialSIList;
	// 	state.imageSpecialSIList = arr.data.Report.ImageSpecialSIList === null ? [] : arr.data.Report.ImageSpecialSIList;
	// 	state.totalScore = arr.data.Report;
	// 	state.reviewName.SubjectType = arr.data.Report.SubjectType;
	// 	if (state.reportDetails.AllImage && state.reportDetails.AllImage != '') {
	// 		state.reportDetails.AllImage = state.reportDetails.AllImage.split(',');
	// 	}

	// 	if (state.reportDetails.KeyImage && state.reportDetails.KeyImage != '') {
	// 		state.reportDetails.KeyImage = state.reportDetails.KeyImage.split(',');
	// 	}
	// 	if (state.reportDetails.PacsUrl && state.reportDetails.PacsUrl != '') {
	// 		state.reportDetails.PacsUrl = state.reportDetails.PacsUrl.split('|');
	// 	}
	// 	if (arr.data.Report.ImageQCList) {
	// 		state.doctorQCImg = arr.data.Report.ImageQCList;
	// 		state.doctorQCImg.forEach(item => {
	// 			item.notSelected = false;
	// 			item.notFilledIn = false;
	// 		})
	// 	}
	// 	let doctorQCImg = arr.data.Report.ReportQCList;
	// 	if (state.doctorTaskStatus == '125') {
	// 		for (let i = 0; i < doctorQCImg.length; i++) {
	// 			doctorQCImg[i].IsNoteShow = true;
	// 		}
	// 		state.doctorQCReport = doctorQCImg;
	// 	} else {
	// 		state.doctorQCReport = arr.data.Report.ReportQCList;
	// 	}
	// 	if(state.doctorQCReport != null){
	// 		state.doctorQCReport.forEach(item => {
	// 			item.notSelected = false;
	// 			item.notFilledIn = false;
	// 		})
	// 	}
	// 	state.gradeIndex = 0;
	// 	state.remark.img = arr.data.Report.ImageNote;
	// 	state.remark.imgNum = arr.data.Report.ImageImpressionScore;
	// 	state.remark.report = arr.data.Report.ReportNote;
	// 	state.remark.reportNum = arr.data.Report.ReportImpressionScore;

	// 	//tab切换
	// 	state.grade = [];
	// 	let imgs = state.doctorQCImg != null ? true : false,
	// 		reports = state.doctorQCReport != null ? true : false;
	// 	if (imgs && reports) {
	// 		state.gradeType = 'report'
	// 	} else if (imgs) {
	// 		state.gradeType = 'img'
	// 	} else {
	// 		state.gradeType = 'report'
	// 	}
	// 	if (reports) {
	// 		state.grade.push({
	// 			name: '报告评分',
	// 			type: 'report'
	// 		})
	// 	}
	// 	if (imgs) {
	// 		state.grade.push({
	// 			name: '影像评分',
	// 			type: 'img',
	// 		})
	// 	}
	// 	let role = JSON.parse(localStorage.getItem('user')).roleName;
	// 	if (role.contain('技师')) {
	// 		state.gradeIndex = 1;
	// 		state.gradeType = 'img';
	// 	} else {
	// 		state.gradeIndex = 0;
	// 		state.gradeType = 'report';
	// 	}
	// 	if (role.contain('仲裁管理') || role.contain('仲裁专家')) {
	// 		if (state.adminappealParameter.type == 3) {
	// 			state.gradeIndex = 1;
	// 			state.gradeType = 'img';
	// 		} else {
	// 			state.gradeIndex = 0;
	// 			state.gradeType = 'report';
	// 		}
	// 	}
	// },
	// 申诉严重扣分项
	SetReportDetailserious(state, arr) {
		console.log(arr,'arr222222222222222');
		state.reportSpecialSIListserious = arr.data.Report.ReportSpecialSIList === null ? [] : arr.data.Report.ReportSpecialSIList;
		state.imageSpecialSIListserious = arr.data.Report.ImageSpecialSIList === null ? [] : arr.data.Report.ImageSpecialSIList;
		state.totalScoreserious = arr.data.Report;
		if (arr.data.Report.ImageQCList) {
			state.doctorQCImgserious = arr.data.Report.ImageQCList;
			state.doctorQCImgserious.forEach(item => {
				item.notSelected = false;
				item.notFilledIn = false;
			})
		}
		let doctorQCImgserious = arr.data.Report.ReportQCList;
		if (state.doctorTaskStatus == '125') {
			for (let i = 0; i < doctorQCImgserious.length; i++) {
				doctorQCImgserious[i].IsNoteShow = true;
			}
			state.doctorQCReportserious = doctorQCImgserious;
		} else {
			state.doctorQCReportserious = arr.data.Report.ReportQCList;
		}
		state.doctorQCReportserious.forEach(item => {
			item.notSelected = false;
			item.notFilledIn = false;
		})
		state.remarkserious.img = arr.data.Report.ImageNote;
		state.remarkserious.imgNum = arr.data.Report.ImageImpressionScore;
		state.remarkserious.report = arr.data.Report.ReportNote;
		state.remarkserious.reportNum = arr.data.Report.ReportImpressionScore;
	},
	// 申诉严重扣分项修改后查看详情
	SetReportRescoresDetailserious(state, arr) {
		state.reportSpecialSIListserious = arr.data.Rescore.SpecialScoreList;
		state.imageSpecialSIListserious = arr.data.Rescore.SpecialScoreList;
		if (arr.data.Rescore.ScoreList) {
			state.doctorQCImgserious = arr.data.Rescore.ScoreList;
			state.doctorQCImgserious.forEach(item => {
				item.notSelected = false;
				item.notFilledIn = false;
			})
		}
		let doctorQCImgserious = arr.data.Rescore.ScoreList;
		if (state.doctorTaskStatus == '125') {
			for (let i = 0; i < doctorQCImgserious.length; i++) {
				doctorQCImgserious[i].IsNoteShow = true;
			}
			state.doctorQCReportserious = doctorQCImgserious;
		} else {
			state.doctorQCReportserious = arr.data.Rescore.ScoreList;
		}
		state.doctorQCReportserious.forEach(item => {
			item.notSelected = false;
			item.notFilledIn = false;
		})
		state.remarkserious.img = arr.data.Rescore.ImageNote;
		state.remarkserious.imgNum = arr.data.Rescore.ImageImpressionScore;
		state.remarkserious.report = arr.data.Rescore.ReportNote;
		state.remarkserious.reportNum = arr.data.Rescore.ReportImpressionScore;
		if (state.gradeType == 'report') {
			state.totalScoreserious.ReportScore = arr.data.Rescore.ExpertScore == 0 ? arr.data.Rescore.ManagerScore : arr.data.Rescore.ExpertScore;
		} else {
			state.totalScoreserious.ImageScore = arr.data.Rescore.ExpertScore == 0 ? arr.data.Rescore.ManagerScore : arr.data.Rescore.ExpertScore;
		}
	},
	// 申诉严重扣分项
	setIsSubmintserious(state, arr) {
		state.isSubmintserious = arr;
		state.isSeriousSubmintserious.flag = arr;
	},
	// 申诉严重扣分项
	setSpecialListserious(state, item) {
		if (state.gradeType == 'report') {
			state.totalScoreserious.ReportScore = 0;
			state.reportSpecialSIListserious[item.index].Score = item.checked ? 100 : 0;
		} else {
			state.totalScoreserious.ImageScore = 0;
			state.imageSpecialSIListserious[item.index].Score = item.checked ? 100 : 0;
		}
	},
	//申诉严重扣分项报告减分
	setScoreTotileserious(state, arr) {
		if (arr.type == 'img') {
			state.totalScoreserious.ImageScore = arr.num
		}
		if (arr.type == 'report') {
			state.totalScoreserious.ReportScore = arr.num
		}
		if (arr.type == 'history') {
			state.totalScoreserious.HistoryScore = arr.num
		}
	},
	//评分tab切换
	setGradeIndex(state, arr) {
		state.gradeIndex = arr.index;
		state.gradeType = arr.type;
	},
	//报告减分
	setScoreTotile(state, arr) {
		if (arr.type == 'img') {
			state.totalScore.ImageScore = arr.num
		}
		if (arr.type == 'report') {
			state.totalScore.ReportScore = arr.num
		}
		if (arr.type == 'history') {
			state.totalScore.HistoryScore = arr.num
		}
	},
	//提交成功
	saveSubmit(state, arr) {
		if (arr) {
			router.go(-1);
			ELEMENT.Message.success(arr.data.Msg);
		}
	},
	//影像评分是否有备注未填
	setNeedNoteImg(state, val) {
		state.needNoteImg = val
	},
	//报告评分是否有备注未填
	setNeedNoteReport(state, val) {
		state.needNoteReport = val
	},
	//病史评分是否有备注未填
	setNeedNoteHistory(state, val) {
		state.needNoteHistory = val
	},
	//影像评分是否有备注未填
	setNeedNoteImgserious(state, val) {
		state.needNoteImgserious = val
	},
	//报告评分是否有备注未填
	setNeedNoteReportserious(state, val) {
		state.needNoteReportserious = val
	},
	//病史评分是否有备注未填
	setNeedNoteHistoryserious(state, val) {
		state.needNoteHistoryserious = val
	},
	getNeedNote(state) {
		//影像
		if (state.doctorQCImg != null) {
			console.log('影像判断');
			console.log(state.doctorQCImg);
			console.log('影像判断');
			for (let i = 0; i < state.doctorQCImg.length; i++) {
				if (state.doctorQCImg[i].Score != 0 && state.doctorQCImg[i].Score != 500 && (state.doctorQCImg[i].Note == "" ||
					state.doctorQCImg[i].Note == null)) {
					state.doctorQCReportIndex = i;
					state.needNoteImg = true;
					break
				}
			}
			for (let i = 0; i < state.doctorQCImg.length; i++) {
				if (state.doctorQCImg[i].Score != 0 && state.doctorQCImg[i].Score != 500 && (state.doctorQCImg[i].Note == "" ||
					state.doctorQCImg[i].Note == null)) {
					state.doctorQCImg[i].notFilledIn = true;
					state.doctorQCImg[i].IsNoteShow = true;
				}
			}
		}

		//报告  
		if (state.doctorQCReport != null) {
			for (let i = 0; i < state.doctorQCReport.length; i++) {
				if (state.doctorQCReport[i].Score != 0 && state.doctorQCReport[i].Score != 500 && (state.doctorQCReport[i].Note ==
					"" || state.doctorQCReport[i].Note == null)) {
					state.doctorQCReportIndex = i;
					state.needNoteReport = true
					break
				}
			}
			for (let i = 0; i < state.doctorQCReport.length; i++) {
				if (state.doctorQCReport[i].Score != 0 && state.doctorQCReport[i].Score != 500 && (state.doctorQCReport[i].Note ==
					"" || state.doctorQCReport[i].Note == null)) {
					state.doctorQCReport[i].notFilledIn = true;
					state.doctorQCReport[i].IsNoteShow = true;
				}
			}
		}
		// 病史
		if (state.doctorQCHistory != null) {
			for (let i = 0; i < state.doctorQCHistory.length; i++) {
				if (state.doctorQCHistory[i].Score != 0 && state.doctorQCHistory[i].Score != 500 && (state.doctorQCHistory[i].Note ==
					"" || state.doctorQCHistory[i].Note == null)) {
					state.doctorQCHistoryIndex = i;
					state.needNoteHistory = true;
					break
				}
			}
			for (let i = 0; i < state.doctorQCHistory.length; i++) {
				if (state.doctorQCHistory[i].Score != 0 && state.doctorQCHistory[i].Score != 500 && (state.doctorQCHistory[i].Note ==
					"" || state.doctorQCHistory[i].Note == null)) {
					state.doctorQCHistory[i].notFilledIn = true;
					state.doctorQCHistory[i].IsNoteShow = true;
				}
			}
		}
	},
	// 严重扣分项申诉提交的时候验证
	getNeedNoteserious(state) {
		//影像
		if (state.doctorQCImgserious != null) {
			for (let i = 0; i < state.doctorQCImgserious.length; i++) {
				if (state.doctorQCImgserious[i].Score != 0 && state.doctorQCImgserious[i].Score != 500 && (state.doctorQCImgserious[i].Note == "" ||
					state.doctorQCImgserious[i].Note == null)) {
					state.doctorQCReportIndexserious = i;
					state.needNoteImgserious = true;
					break
				}
			}
			for (let i = 0; i < state.doctorQCImgserious.length; i++) {
				if (state.doctorQCImgserious[i].Score != 0 && state.doctorQCImgserious[i].Score != 500 && (state.doctorQCImgserious[i].Note == "" ||
					state.doctorQCImgserious[i].Note == null)) {
					state.doctorQCImgserious[i].notFilledIn = true;
					state.doctorQCImgserious[i].IsNoteShow = true;
				}
			}
		}

		//报告  
		if (state.doctorQCReportserious != null) {
			for (let i = 0; i < state.doctorQCReportserious.length; i++) {
				if (state.doctorQCReportserious[i].Score != 0 && state.doctorQCReportserious[i].Score != 500 && (state.doctorQCReportserious[i].Note ==
					"" || state.doctorQCReportserious[i].Note == null)) {
					state.doctorQCReportIndexserious = i;
					state.needNoteReportserious = true
					break
				}
			}
			for (let i = 0; i < state.doctorQCReportserious.length; i++) {
				if (state.doctorQCReportserious[i].Score != 0 && state.doctorQCReportserious[i].Score != 500 && (state.doctorQCReportserious[i].Note ==
					"" || state.doctorQCReportserious[i].Note == null)) {
					state.doctorQCReportserious[i].notFilledIn = true;
					state.doctorQCReportserious[i].IsNoteShow = true;
				}
			}
		}
		// 病史
		if (state.doctorQCHistoryserious != null) {
			for (let i = 0; i < state.doctorQCHistoryserious.length; i++) {
				if (state.doctorQCHistoryserious[i].Score != 0 && state.doctorQCHistoryserious[i].Score != 500 && (state.doctorQCHistoryserious[i].Note ==
					"" || state.doctorQCHistoryserious[i].Note == null)) {
					state.doctorQCHistoryIndexserious = i;
					state.needNoteHistoryserious = true;
				}
				break
			}
			for (let i = 0; i < state.doctorQCHistoryserious.length; i++) {
				if (state.doctorQCHistoryserious[i].Score != 0 && state.doctorQCHistoryserious[i].Score != 500 && (state.doctorQCHistoryserious[i].Note ==
					"" || state.doctorQCHistoryserious[i].Note == null)) {
					state.doctorQCHistoryserious[i].notFilledIn = true;
					state.doctorQCHistoryserious[i].IsNoteShow = true;
				}
			}
		}
	},
	//影像评分是否有没有分数
	setAnyNoScoreImg(state, val) {
		state.anyNoScoreImg = val
	},
	//报告评分是否有没有分数
	setAnyNoScoreReport(state, val) {
		state.anyNoScoreReport = val
	},
	//影像评分是否有没有分数
	setAnyNoScoreImgserious(state, val) {
		state.anyNoScoreImgserious = val
	},
	//报告评分是否有没有分数
	setAnyNoScoreReportserious(state, val) {
		state.anyNoScoreReportserious = val
	},
	//病史评分是否有没有分数
	setAnyNoScoreHistory(state, val) {
		state.anyNoScoreHistory = val
	},
	//病史评分是否有没有分数
	setAnyNoScoreHistoryserious(state, val) {
		state.anyNoScoreHistoryserious = val
	},
	getNoScore(state) {
		//影像
		if (state.doctorQCImg != null) {
			for (let i = 0; i < state.doctorQCImg.length; i++) {
				if (state.doctorQCImg[i].Score == 500) {
					state.doctorQCReportIndex = i;
					state.anyNoScoreImg = true
					state.doctorQCImg[i].notSelected = true;
					break
				}
			}
			for (let i = 0; i < state.doctorQCImg.length; i++) {
				if (state.doctorQCImg[i].Score == 500) {
					state.doctorQCImg[i].notSelected = true;
				}
			}
			state.doctorQCImg = _.cloneDeep(state.doctorQCImg)
		}

		//报告 
		if (state.doctorQCReport != null) {
			for (let i = 0; i < state.doctorQCReport.length; i++) {
				if (state.doctorQCReport[i].Score == 500) {
					state.doctorQCReportIndex = i;
					state.anyNoScoreReport = true
					state.doctorQCReport[i].notSelected = true;
					break
				}
			}
			for (let i = 0; i < state.doctorQCReport.length; i++) {
				if (state.doctorQCReport[i].Score == 500) {
					state.doctorQCReport[i].notSelected = true;
				}
			}
			state.doctorQCReport = _.cloneDeep(state.doctorQCReport)
		}
		// 病史
		if (state.doctorQCHistory != null) {
			for (let i = 0; i < state.doctorQCHistory.length; i++) {
				if (state.doctorQCHistory[i].Score == 500) {
					state.doctorQCHistoryIndex = i;
					state.anyNoScoreHistory = true
					state.doctorQCHistory[i].notSelected = true;
					break
				}
			}
			for (let i = 0; i < state.doctorQCHistory.length; i++) {
				if (state.doctorQCHistory[i].Score == 500) {
					state.doctorQCHistory[i].notSelected = true;
				}
			}
			state.doctorQCHistory = _.cloneDeep(state.doctorQCHistory)
		}
	},
	// 严重扣分项申诉修改时候的提交验证
	getNoScoreserious(state) {
		//影像
		if (state.doctorQCImgserious != null) {
			for (let i = 0; i < state.doctorQCImgserious.length; i++) {
				if (state.doctorQCImgserious[i].Score == 500) {
					state.doctorQCReportIndexserious = i;
					state.anyNoScoreImgserious = true
					state.doctorQCImgserious[i].notSelected = true;
					break
				}
			}
			for (let i = 0; i < state.doctorQCImgserious.length; i++) {
				if (state.doctorQCImgserious[i].Score == 500) {
					state.doctorQCImgserious[i].notSelected = true;
				}
			}
			state.doctorQCImgserious = JSON.parse(JSON.stringify(state.doctorQCImgserious))
		}

		//报告 
		if (state.doctorQCReportserious != null) {
			for (let i = 0; i < state.doctorQCReportserious.length; i++) {
				if (state.doctorQCReportserious[i].Score == 500) {
					// console.log(state.doctorQCReportserious[i]);
					state.doctorQCReportIndexserious = i;
					state.anyNoScoreReportserious = true
					state.doctorQCReportserious[i].notSelected = true;
					break
				}
			}
			for (let i = 0; i < state.doctorQCReportserious.length; i++) {
				if (state.doctorQCReportserious[i].Score == 500) {
					state.doctorQCReportserious[i].notSelected = true;
				}
			}
			state.doctorQCReportserious = JSON.parse(JSON.stringify(state.doctorQCReportserious))
		}
		// 病史
		if (state.doctorQCHistoryserious != null) {
			for (let i = 0; i < state.doctorQCHistoryserious.length; i++) {
				if (state.doctorQCHistoryserious[i].Score == 500) {
					state.doctorQCHistoryIndexserious = i;
					state.anyNoScoreHistoryserious = true
					state.doctorQCHistoryserious[i].notSelected = true;
					break
				}
			}
		}
		for (let i = 0; i < state.doctorQCHistoryserious.length; i++) {
			if (state.doctorQCHistoryserious[i].Score == 500) {
				state.doctorQCHistoryserious[i].notSelected = true;
			}
		}
		state.doctorQCHistoryserious = _.cloneDeep(state.doctorQCHistoryserious)
	},
	GetDashboradMu(state, res) {
		state.DashboradList = res.data;
	},
	setAppealInfoList(state, res) {
		state.appealInfoList = res.data.AppealInfos;
	},
	setExpertList(state, res) {
		state.expertList = res.data;
	},
	setadminAppealInfoList(state, arr) {
		state.adminappealInfoList = arr.data;
	},
	setAppealExpertList(state, arr) {
		state.appealExpertList = arr.data;
	}
};
const actions = {
	//审核医生首页数据
	GetDashborad({
		commit,
		state
	}) {
		commit('breadcrumb/setLoading', true, { root: true })
		axios.ajaxGet('get', Api.api.doctor.GetDashborad, state.reportDoctorPar).then(res => {
			commit('getDashboradMu', res)
			commit('setChartsLoading', false)
			// commit('breadcrumb/setLoading',false,{root:true})
		})
	},
	//审核医生
	GetReporterReportList({
		commit,
		state
	}) {
		commit('breadcrumb/setLoading', true, { root: true })
		state.getReporterReportListArr = {
			PageIndex: state.pageIndex.page,
			PageCount: state.listParameter.PageCount,
			keyName: state.listParameter.keyName,
			startDate: state.listParameter.startDate,
			endDate: state.listParameter.endDate,
			type: state.listParameter.type,
			status: state.exportTackStatus,
			isRead: state.listParameter.isRead,
			samplingTaskGuid: state.samplingTaskGuid.id,
			isUnqualified: state.getReporterReportListArr.isUnqualified,
			scoreItem: state.getReporterReportListArr.scoreItem
		}
		axios.ajaxGet('get', Api.api.doctor.GetReporterReportList, state.getReporterReportListArr).then(res => {
			commit('SetReporterReportList', res)
			commit('breadcrumb/setLoading', false, { root: true })
		})
	},
	UpdateReportReadStatus({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		axios.ajaxPost('post', Api.api.doctor.UpdateReportReadStatus, {
			ReportIds: state.ReportIds,
			SamplingTaskGuid: arr.samplingTaskGuid,
			ExpertUserGuid: state.samplingTaskGuid.ExpertUserId,
		}).then(res => {
			commit('breadcrumb/setLoading', false, { root: true })
		})
	},

	//报告专家
	GetExpertTaskList({
		commit,
		state
	}) {
		commit('breadcrumb/setLoading', true, { root: true })
		axios.ajaxGet('get', Api.api.experts.GetExpertReportList, {
			status: state.doctorTaskStatus, //
			keyName: state.listParameter.keyName, //关键词搜索
			startDate: state.listParameter.startDate, //开始时间
			endDate: state.listParameter.endDate, //结束时间
			PageIndex: state.pageIndex.page, //分页
			PageCount: state.listParameter.PageCount, //分页
			samplingTaskGuid: state.samplingTaskGuid.id,
			isUnqualified: state.samplingTaskGuid.isUnqualified
		}).then(res => {
			commit('setExpertTaskList', res)
			commit('breadcrumb/setLoading', false, { root: true })
		})
	},
	//申诉严重扣分项查看详情
	GetReportDetailserious({
		commit,
		state
	}) {
		commit('setAppealLoading', true)
		return axios.ajaxGet('get', Api.api.doctor.GetReportDetail2, state.detaisParameter).then(res => {
			commit('SetReportDetailserious', res)
			commit('setAppealLoading', false)
		}).finally(() => { });
	},
	//申诉严重扣分项修改后的查看详情
	GetAppealRescoresDetailserious({
		commit,
		state
	}, arr) {
		commit('setAppealLoading', true)
		return axios.ajaxGet('get', Api.api.experts.GetAppealRescoresDetail, arr).then(res => {
			commit('SetReportRescoresDetailserious', res)
			commit('setAppealLoading', false)
		}).finally(() => { });
	},
	//申诉严重扣分项提交仲裁管理员
	RescoreQcadminAppeal({
		commit,
		state,
		dispatch
	}, arr) {
		return axios.ajaxPost('post', Api.api.experts.RescoreQcadminAppeal, arr).then(res => {
			commit('setspecialDrawer', false)
		}).finally(() => { });
	},
	//申诉严重扣分项提交仲裁专家
	RescoreAppeal({
		commit,
		state,
		dispatch
	}, arr) {
		return axios.ajaxPost('post', Api.api.experts.RescoreAppeal, arr).then(res => {
			commit('setspecialDrawer', false)
		}).finally(() => { });
	},
	//医生查看详情
	GetReportDetail({
		commit,
		state
	}) {
		commit('breadcrumb/setLoading', true, { root: true })
		return axios.ajaxGet('get', Api.api.doctor.GetReportDetail2, state.detaisParameter).then(res => {
			commit('breadcrumb/setLoading', false, { root: true })
			commit('setDetalLoading', false)
			commit('SetReportDetail', res)
		}).finally(() => { });
	},
	//医生查看详情
	GetReportInfo({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		axios.ajaxGet('get', Api.api.manager.GetReportInfo, arr).then(res => {
			commit('breadcrumb/setLoading', false, { root: true })
			commit('setDetalLoading', false)
			commit('SetReportinfo', res)
		})
	},
	//提交
	CreateOrUpdateQC({
		commit,
		state,
		dispatch
	}) {
		commit('breadcrumb/setLoading', true, { root: true })
		console.log(state.doctorQCImg);
		console.log(state.doctorQCReport == null ? [] : state.doctorQCReport);
		console.log(state.reportSpecialSIList);
		console.log(state.imageSpecialSIList);
		const imageQCList = convertOptionGuid(state.doctorQCImg == null ? [] : state.doctorQCImg);
		const reportQCList = convertOptionGuid(state.doctorQCReport == null ? [] : state.doctorQCReport);
		const reportSpecialSIList = convertOptionGuid(state.reportSpecialSIList == null ? [] : state.reportSpecialSIList);
		const imageSpecialSIList = convertOptionGuid(state.imageSpecialSIList == null ? [] : state.imageSpecialSIList);
		const historyQCList = convertOptionGuid(state.doctorQCHistory == null ? [] : state.doctorQCHistory);
		const historySpecialSIList = convertOptionGuid(state.historySpecialSIList == null ? [] : state.historySpecialSIList);
		// // 创建数据的深拷贝
		// const imageQCList = _.cloneDeep(state.doctorQCImg);

		// imageQCList.forEach(item => {
		// 	// 将 OptionGuid 从数组转换为字符串
		// 	if (Array.isArray(item.OptionGuid)) {
		// 		item.OptionGuid = item.OptionGuid.join(','); // 使用逗号连接数组元素
		// 	}
		// });
		// const reportQCList = _.cloneDeep(state.doctorQCReport);

		// reportQCList.forEach(item => {
		// 	// 将 OptionGuid 从数组转换为字符串
		// 	if (Array.isArray(item.OptionGuid)) {
		// 		item.OptionGuid = item.OptionGuid.join(','); // 使用逗号连接数组元素
		// 	}
		// });
		// const reportSpecialSIList = _.cloneDeep(state.reportSpecialSIList);

		// reportSpecialSIList.forEach(item => {
		// 	// 将 OptionGuid 从数组转换为字符串
		// 	if (Array.isArray(item.OptionGuid)) {
		// 		item.OptionGuid = item.OptionGuid.join(','); // 使用逗号连接数组元素
		// 	}
		// });
		// const imageSpecialSIList = _.cloneDeep(state.imageSpecialSIList);

		// imageSpecialSIList.forEach(item => {
		// 	// 将 OptionGuid 从数组转换为字符串
		// 	if (Array.isArray(item.OptionGuid)) {
		// 		item.OptionGuid = item.OptionGuid.join(','); // 使用逗号连接数组元素
		// 	}
		// });
		let rep = {
			ReportGuid: state.detaisParameter.reportGuid,
			SamplingTaskGuid: state.detaisParameter.samplingTaskGuid,
			ReportQCList: reportQCList,
			ImageQCList: imageQCList,
			ImageNote: state.remark.img,
			ImageImpressionScore: state.remark.imgNum,
			ReportSpecialList: reportSpecialSIList,
			ImageSpecialList: imageSpecialSIList,
			ReportNote: state.remark.report,
			ReportImpressionScore: state.remark.reportNum,
			SubjectiveHistoryQCList: historyQCList,
			SubjectiveHistorySpecialList: historySpecialSIList,
			SubjectiveHistoryImpressionScore: state.remark.historyNum,
			SubjectiveHistoryNote: state.remark.history,
			ReportDiseaseResult: {
				DiseaseType: "TB",
				DiagnoseResult: "",
				ResultPercent: "",
				Note: "",
			}
		}
		axios.ajaxPost('post', Api.api.experts.CreateOrUpdateQC2, rep).then(res => {
			console.log('Request succeeded:', res);
			if (state.role == 'export') {
				commit('exportDoctorStatus', '120')
				dispatch('GetExpertTaskList');
			} else {
				dispatch('GetReporterReportList');
			}
			commit('saveSubmit', res)
			commit('breadcrumb/setLoading', false, { root: true })
		})
	},
	//暂存
	SaveQCTmp({
		commit,
		state,
		dispatch
	}) {
		commit('breadcrumb/setLoading', true, { root: true })
		const imageQCList = convertOptionGuid(state.doctorQCImg == null ? [] : state.doctorQCImg);
		const reportQCList = convertOptionGuid(state.doctorQCReport == null ? [] : state.doctorQCReport);
		const reportSpecialSIList = convertOptionGuid(state.reportSpecialSIList == null ? [] : state.reportSpecialSIList);
		const imageSpecialSIList = convertOptionGuid(state.imageSpecialSIList == null ? [] : state.imageSpecialSIList);
		const historyQCList = convertOptionGuid(state.doctorQCHistory == null ? [] : state.doctorQCHistory);
		const historySpecialSIList = convertOptionGuid(state.historySpecialSIList == null ? [] : state.historySpecialSIList);
		let rep = {
			ReportGuid: state.detaisParameter.reportGuid,
			SamplingTaskGuid: state.detaisParameter.samplingTaskGuid,
			ReportQCList: reportQCList,
			ImageQCList: imageQCList,
			ReportSpecialList: reportSpecialSIList,
			ImageSpecialList: imageSpecialSIList,
			SubjectiveHistoryQCList: historyQCList,
			SubjectiveHistorySpecialList: historySpecialSIList,
			ImageNote: state.remark.img,
			ImageImpressionScore: state.remark.imgNum,
			ReportNote: state.remark.report,
			ReportImpressionScore: state.remark.reportNum,
			SubjectiveHistoryImpressionScore: state.remark.historyNum,
			SubjectiveHistoryNote: state.remark.history,
			ReportDiseaseResult: {
				DiseaseType: "TB",
				DiagnoseResult: "",
				ResultPercent: "",
				Note: "",
			}
		}
		axios.ajaxPost('post', Api.api.experts.SaveQCTmp2, rep).then(res => {
			//          dispatch('expertinfoGetTaskList');
			if (state.role == 'export') {
				commit('exportDoctorStatus', '125')
				dispatch('GetExpertTaskList');
			} else {
				dispatch('GetReporterReportList');
			}
			commit('saveSubmit', res)
			commit('breadcrumb/setLoading', false, { root: true })
		})
	},
	//质控专家首页数据
	GetDashboradExpert({
		state,
		commit,
		dispatch
	}) {
		commit('breadcrumb/setLoading', true, { root: true })
		axios.ajaxGet('get', Api.api.experts.GetDashboradExpert, state.DashboradArr).then(res => {
			commit('GetDashboradMu', res);
			commit('setChartsLoading', false)
			commit('breadcrumb/setLoading', false, { root: true })
		})
	},
	//审核医生任务列表
	GetTaskList(context) {
		context.rootState.breadcrumb.loading = true;
		// commit('breadcrumb/setLoading',true,{root:true})
		context.rootState.doctor.TaskListArr.keyword = context.rootState.doctor.listParameter.keyName;
		context.rootState.doctor.TaskListArr.pageIndex = context.rootState.doctor.listParameter.PageIndex;
		context.rootState.doctor.TaskListArr.statusList = context.rootState.doctor.statusList;

		axios.ajaxGet('get', Api.api.doctor.GetTaskList, context.rootState.doctor.TaskListArr).then(res => {
			context.commit('GetTaskListMu', res);
			// commit('breadcrumb/setLoading',false,{root:true})
			context.rootState.breadcrumb.loading = false;
		})
	},
	//专家任务列表
	expertinfoGetTaskList({
		state,
		commit,
	}) {
		commit('breadcrumb/setLoading', true, { root: true })
		state.expertinfoTaskListArr.keyword = state.listParameter.keyName;
		state.expertinfoTaskListArr.pageIndex = state.listParameter.PageIndex;
		axios.ajaxGet('get', Api.api.experts.GetTaskList, state.expertinfoTaskListArr).then(res => {
			commit('expertinfoGetTaskListMu', res);
			commit('breadcrumb/setLoading', false, { root: true })
		})
	},
	//任务详情-报告列表-专家列表
	GetQCResultsByTask({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		axios.ajaxGet('get', Api.api.manager.GetQCResultsByTask, {
			samplingtaskguid: arr.samplingtaskguid,
			reportGuid: arr.reportGuid
		}).then(res => {
			commit('GetQCResultsByTaskMu', res)
			commit('breadcrumb/setLoading', false, { root: true })
		})
	},
	//申诉列表
	GetAppealInfoList({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		axios.ajaxGet('get', Api.api.doctor.GetAppealInfoList, state.appealParameter).then(res => {
			commit('setAppealInfoList', res)
			commit('breadcrumb/setLoading', false, { root: true })
		})
	},
	//仲裁专家申诉列表
	GetExpertAppealInfoList({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		axios.ajaxGet('get', Api.api.manager.GetExpertAppealInfoList, state.expertParameter).then(res => {
			commit('setExpertList', res)
			commit('breadcrumb/setLoading', false, { root: true })
		})
	},

	// 发起申诉
	CreateAppealInfo({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		state.appealInfo = arr;
		return axios.ajaxPost('post', Api.api.doctor.CreateAppealInfo, state.appealInfo).then(res => {
			commit('breadcrumb/setLoading', false, { root: true })
			commit('drawerShow', false)
		}).finally(() => { });
	},
	GetAppealDetail({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setlocalLoading', true, { root: true })
		return axios.ajaxGet('get', Api.api.doctor.GetAppealDetail, arr).then(res => {
			commit('setAppealDetail', res)
			commit('breadcrumb/setlocalLoading', false, { root: true })
		}).finally(() => { });
	},
	// 取消申诉
	CancelAppealInfo({
		commit,
		state,
		dispatch
	}, arr) {
		commit('breadcrumb/setlocalLoading', true, { root: true })
		return axios.ajaxPost('post', Api.api.doctor.CancelAppealInfo, arr).then(res => {
			dispatch('GetAppealInfoList')
			commit('breadcrumb/setlocalLoading', false, { root: true })
		}).finally(() => { });
	},
	//仲裁管理员申诉列表
	GetadminAppealInfoList({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		axios.ajaxGet('get', Api.api.manager.GetAppealInfoList, state.adminappealParameter).then(res => {
			commit('setadminAppealInfoList', res)
			commit('breadcrumb/setLoading', false, { root: true })
		})
	},
	// 仲裁专家处理
	ManageAppeal({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		return axios.ajaxPost('post', Api.api.manager.ManageAppeal, arr).then(res => {
			commit('breadcrumb/setLoading', false, { root: true })
		}).finally(() => { });
	},
	// 仲裁管理员审核
	CheckAppeal({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		return axios.ajaxPost('post', Api.api.manager.CheckAppeal, arr).then(res => {
			commit('breadcrumb/setLoading', false, { root: true })
		}).finally(() => { });
	},
	// 仲裁管理员直接处理
	QCAdminManageAppeal({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		return axios.ajaxPost('post', Api.api.manager.QCAdminManageAppeal, arr).then(res => {
			commit('breadcrumb/setLoading', false, { root: true })
		}).finally(() => { });
	},
	// 仲裁管理员转发
	DistributeAppeal({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		return axios.ajaxPost('post', Api.api.manager.DistributeAppeal, arr).then(res => {
			commit('breadcrumb/setLoading', false, { root: true })
		}).finally(() => { });
	},
	// 仲裁专家列表
	GetAppealExpertList({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		return axios.ajaxPost('post', Api.api.manager.GetAppealExpertList, state.appealExpertListParameter).then(res => {
			commit('setAppealExpertList', res);
			commit('breadcrumb/setLoading', false, { root: true })
		}).finally(() => { });
	},
	// 申诉医生/技师认可
	AdmitAppeal({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		return axios.ajaxPost('post', Api.api.doctor.AdmitAppeal, arr).then(res => {
			commit('breadcrumb/setLoading', false, { root: true })
		}).finally(() => { });
	},
	// 专家撤回报告
	ReturnSamplingReport({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		return axios.ajaxPost('post', Api.api.experts.ReturnSamplingReport, arr).then(res => {
			commit('breadcrumb/setLoading', false, { root: true })
		}).finally(() => { });
	},
	// 撤回申诉上一个状态
	RollBackAppealById({
		commit,
		state
	}, arr) {
		commit('breadcrumb/setLoading', true, { root: true })
		return axios.ajaxPost('post', Api.api.experts.RollBackAppealById, arr).then(res => {
			commit('breadcrumb/setLoading', false, { root: true })
		}).finally(() => { });
	},
}
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
